import { useState } from "react";
import styled from "@emotion/styled";
import { Card, CardHeader, CardContent, Grid, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";

import { BasicFlex, InputLabel } from "../../Common";

import DownloadButton from "./DownloadButton";
import ShareButton from "./ShareButton";
import EmailButton from "./EmailButton";

import ErrorMessage from "../../MuiFields/ErrorMessage";

const isValidEmail = (email) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

const ShareCard = ({ url, defaultEmail, title = "Invoice Actions" }) => {

  const [email, setEmail] = useState(defaultEmail);
  const [docType, setDocType] = useState("pdf");


  return (
    <Card variant="outlined" sx={{width: "100%"}}>
      <CardHeader 
      title={title} 
      action={
        <BasicFlex gap=".5rem">
          <ShareButton apiUrl={url} />
          <DownloadButton url={url} doc_type={docType} />
          <EmailButton url={url} disabled={!email || !isValidEmail(email)} email={email} doc_type={docType} />
        </BasicFlex>
      }
      />
      <CardContent sx={{pt: 0}}>

        <ToggleButtonGroup size="small" color="secondary" value={docType} onChange={(e, val) => setDocType(val)} exclusive sx={{mb: "2rem"}}>
          <ToggleButton value="pdf" sx={{width: "12rem"}}>PDF</ToggleButton>
          <ToggleButton value="csv" sx={{width: "12rem"}} disabled>CSV</ToggleButton>
        </ToggleButtonGroup>
        
        <InputLabel>Enter Email</InputLabel>
        <TextField fullWidth size="small" value={email} onChange={(e) => setEmail(e.target.value)} />
          {email && !isValidEmail(email) && <ErrorMessage error={!isValidEmail(email)} message="Please enter a valid email address." /> }
        
      </CardContent>
    </Card>
  )
};

export default ShareCard;